import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7aa33209"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "toggle-container" }
const _hoisted_2 = ["onClick"]

import { ref, computed, watch, onMounted, withDefaults } from 'vue'

interface Props {
  options?: string[]
  modelValue?: string
}


export default /*#__PURE__*/_defineComponent({
  props: {
    options: { default: () => ['日', '月', '年'] },
    modelValue: { default: '日' }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as { options: string[], modelValue: string }





const itemRefs = ref<HTMLButtonElement[]>([])
const gliderStyle = ref({})

const updateGlider = () => {
  const activeIndex = props.options.indexOf(props.modelValue)
  if (activeIndex === -1 || !itemRefs.value[activeIndex]) {
    return
  }

  const activeItem = itemRefs.value[activeIndex]
  const { offsetLeft, offsetWidth } = activeItem

  gliderStyle.value = {
    transform: `translateX(${offsetLeft}px)`,
    width: `${offsetWidth}px`,
  }
}

/**
 * 当用户点击选项时触发
 * @param option 被选中的选项字符串
 */
const selectOption = (option: string) => {
  emit('update:modelValue', option)
}

// --- 生命周期钩子 ---
// 组件挂载后，初始化滑块位置
onMounted(() => {
  // 使用 nextTick 确保DOM元素已经渲染完成
  // 但对于动态宽度的按钮，最好在监听到refs变化后更新
  setTimeout(updateGlider, 50) // 短暂延迟确保渲染完毕
})

// 监听 v-model 的变化，并更新滑块位置
watch(
  () => props.modelValue,
  () => {
    updateGlider()
  },
)

// 监听选项数组的变化（如果它是动态的）
watch(
  () => props.options,
  () => {
    // 确保在DOM更新后执行
    setTimeout(updateGlider, 50)
  },
  { deep: true },
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "glider",
      style: _normalizeStyle(gliderStyle.value)
    }, null, 4),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option, index) => {
      return (_openBlock(), _createElementBlock("button", {
        key: option,
        ref_for: true,
        ref: el => { if (el) itemRefs.value[index] = el as HTMLButtonElement },
        onClick: ($event: any) => (selectOption(option)),
        class: _normalizeClass(["toggle-option", { active: __props.modelValue === option }])
      }, _toDisplayString(option), 11, _hoisted_2))
    }), 128))
  ]))
}
}

})